import React, { Component } from 'react';
import Style from './index.less';
import classNames from 'classnames';
import {
    EffectPropsField,
    DefaultEffectPresetProps,
} from '@src/framework/editor/src/js/constants';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';
import { EMPTY_EFFECT } from '../preset-util/base-preset-util';
import { IMAGE_PRESET_ICONS, SHAPE_PRESET_ICONS } from './preset-icons/index';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import { PresetElementType } from '@src/framework/workbench/const/preset-element-type';

const SoftEdgeStyleAndPropsMapping = {
    'soft-empty-click': null,
    'soft-empty-hover': {
        [EffectPropsField.SIZE.name]: 0,
    },
    'soft-1': {
        [EffectPropsField.SIZE.name]: 1,
    },
    'soft-2.5': {
        [EffectPropsField.SIZE.name]: 2.5,
    },
    'soft-5': {
        [EffectPropsField.SIZE.name]: 5,
    },
    'soft-10': {
        ...DefaultEffectPresetProps[ActionType.SOFTEDGE],
    },
    'soft-25': {
        [EffectPropsField.SIZE.name]: 25,
    },
    'soft-50': {
        [EffectPropsField.SIZE.name]: 50,
    },
} as const;

type SoftEdgeStyle = typeof SoftEdgeStyleAndPropsMapping[keyof typeof SoftEdgeStyleAndPropsMapping];

interface SoftEdgePresetMenuProps {
    preset: { style: string };
    onSoftEdgePresetStyleClick: (value: SoftEdgeStyle) => void;
    onSoftEdgePresetStyleMouseEnter: (value: SoftEdgeStyle) => void;
    onSoftEdgePresetStyleMouseLeave: () => void;
    presetElementType?: PresetElementType;
}

const SoftEdgePresetStyleList = [
    {
        style: 'soft-1', title: i18n.t('边缘柔化变体： {0}磅', { 0: 1 }), key: 'soft-1',
    },
    {
        style: 'soft-2.5', title: i18n.t('边缘柔化变体： {0}磅', { 0: 2.5 }), key: 'soft-2.5',
    },
    {
        style: 'soft-5', title: i18n.t('边缘柔化变体： {0}磅', { 0: 5 }), key: 'soft-5',
    },
    {
        style: 'soft-10', title: i18n.t('边缘柔化变体： {0}磅', { 0: 10 }), key: 'soft-10',
    },
    {
        style: 'soft-25', title: i18n.t('边缘柔化变体： {0}磅', { 0: 25 }), key: 'soft-25',
    },
    {
        style: 'soft-50', title: i18n.t('边缘柔化变体： {0}磅', { 0: 50 }), key: 'soft-50',
    },
];

export default class SoftEdgePresetMenu extends Component<SoftEdgePresetMenuProps> {
    public render() {
        const presetList = SoftEdgePresetStyleList;
        const icons = this.getPresetIcons();
        return (
            <div className={classNames(Style.container, 'soft-edge-preset')}>
                <div className={Style['soft-edge-type-title']}>{i18n.t('无柔化边缘')}</div>
                <div className={Style['soft-edge-collection']}>
                    <div className={classNames({
                        [Style['soft-edge-collection-item']]: true,
                        [Style['soft-edge-item-selected']]: EMPTY_EFFECT === this.props.preset.style,
                    })}
                    onClick={() => this.handleSoftEdgePresetIconClick('soft-empty-click')}
                    onMouseEnter={() => this.handleSoftEdgePresetIconMouseEnter('soft-empty-hover')}
                    onMouseLeave={() => this.handleSoftEdgePresetIconMouseLeave()}
                    >
                        <Tooltip placement={['top', 'right']} title={i18n.t('无')}>
                            <div className={Style['preset-icon']}>
                                <img src={icons[EMPTY_EFFECT]}/>
                            </div>
                        </Tooltip>
                    </div>
                </div>
                <div className={Style['soft-edge-type-title']}>{i18n.t('柔化边缘')}</div>
                <div className={Style['soft-edge-collection']}>
                    {presetList.map(item => this.renderSoftEdgePresetIcon(item))}
                </div>
            </div>
        );
    }

    private getPresetIcons = () => {
        if (this.props.presetElementType === PresetElementType.IMAGE) {
            return IMAGE_PRESET_ICONS;
        }
        return SHAPE_PRESET_ICONS;
    };


    private renderSoftEdgePresetIcon(item: { key: string; style: string, title: string }) {
        const isSelected = item.style === this.props.preset.style;
        const icons = this.getPresetIcons();
        const softEdgeItemClass = classNames({
            [Style['soft-edge-collection-item']]: true,
            [Style['soft-edge-item-selected']]: isSelected,
        });
        return (
            <div
                key={item.key}
                className={softEdgeItemClass}
                onMouseEnter={() => this.handleSoftEdgePresetIconMouseEnter(item.style)}
                onClick={() => this.handleSoftEdgePresetIconClick(item.style)}
                onMouseLeave={() => this.handleSoftEdgePresetIconMouseLeave()}
            >
                <Tooltip placement={['top', 'right']} title={i18n.t(item.title)}>
                    <div className={Style['preset-icon']}>
                        <img src={icons[item.style]}/>
                    </div>
                </Tooltip>
            </div>
        );
    }

    private handleSoftEdgePresetIconMouseEnter = (style: string) => {
        const value = SoftEdgeStyleAndPropsMapping[style];
        this.props.onSoftEdgePresetStyleMouseEnter(value ? { ...value } : value);
    };

    private handleSoftEdgePresetIconClick = (style: string) => {
        const value = SoftEdgeStyleAndPropsMapping[style];
        this.props.onSoftEdgePresetStyleClick(value ? { ...value } : value);
    };

    private handleSoftEdgePresetIconMouseLeave = () => {
        this.props.onSoftEdgePresetStyleMouseLeave();
    };
}
